import React, { Component } from "react";
import * as Sentry from "@sentry/react";
import { withTranslation } from "react-i18next";
import { Button, Link, Text } from "~/components-shared";
export class ErrorView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
    this.setState = this.setState.bind(this);
  }
  static getDerivedStateFromError(_) {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      tags: {
        info: `Error View: ${errorInfo}`
      }
    });
    console.error("Uncaught error:", error, errorInfo);
  }
  render() {
    const {
      state,
      props: {
        t: i18n,
        children
      },
      setState
    } = this;
    const handleRetry = () => {
      setState({
        hasError: false
      });
    };
    const handleReload = () => {
      window.location.reload();
    };
    if (state.hasError) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
        element: "h1",
        s: {
          mt: 5,
          mb: 8
        }
      }, "\uD83D\uDE1E ", i18n("ErrorView.title")), /*#__PURE__*/React.createElement(Text, {
        element: "h3",
        s: {
          mb: 6
        }
      }, i18n("ErrorView.subTitle"), ": ", /*#__PURE__*/React.createElement(Link, {
        href: "mailto:support@joyn.one"
      }, "support@joyn.one")), /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        onClick: handleRetry,
        display: "inline-block",
        s: {
          px: 8
        },
        rounded: true
      }, i18n("ErrorView.tryAgain")), /*#__PURE__*/React.createElement(Button, {
        color: "grey",
        onClick: handleReload,
        display: "inline-block",
        s: {
          px: 8,
          ml: 2
        },
        rounded: true
      }, i18n("ErrorView.reload")));
    }
    return children;
  }
}
export default withTranslation()(ErrorView);